/* HLM reveal — the one motion vocabulary. Fade-up on enter, staggered ~90ms. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  root.classList.add('hlm-motion');

  var targets = document.querySelectorAll(
    '.product-card, #MainContent .section-content > *, #MainContent .group-block'
  );
  if (!targets.length) return;

  /* stagger index per parent */
  var counts = new Map();
  targets.forEach(function (el) {
    var p = el.parentElement;
    var i = counts.get(p) || 0;
    counts.set(p, i + 1);
    el.style.setProperty('--hlm-d', Math.min(i, 8) * 90 + 'ms');
    el.classList.add('hlm-reveal');
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hlm-in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );
  targets.forEach(function (el) { io.observe(el); });
})();
